import { USER_REQUEST, USER_ERROR, USER_SUCCESS,USER_UNSET } from "../actions/user";
import axios from 'axios';
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = { status: "", profile: {} };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
};

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST);
    axios({url: process.env.VUE_APP_APIURL+"user/userdata", method: 'GET' })
      .then(resp => {
        commit(USER_SUCCESS, resp);
      })
      .catch(() => {
        commit(USER_ERROR);
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT);
      });
  },
  [USER_UNSET]: ({ commit }) => {
    return new Promise(() => {
      commit(USER_UNSET);
    });
  }
};

const mutations = {
  [USER_REQUEST]: state => {
    state.status = "loading";
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "profile", resp.data);
  },
  [USER_ERROR]: state => {
    state.status = "error";
  },
  [USER_UNSET]: state => {
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};